/**
 * Footer Component
 *
 * Professional footer - No blockchain branding
 * Focus on trust, legal positioning, and enterprise credibility
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <div className="footer-brand-icon">⚖</div>
              <h3 className="footer-brand-name">Evidencer</h3>
            </div>
            <p className="footer-description">
              Professional evidence verification and chain of custody management
              for legal professionals and enterprises.
            </p>
            <div className="footer-trust-badges">
              <div className="trust-badge">
                <span className="trust-icon">✓</span>
                <span>Court Admissible</span>
              </div>
              <div className="trust-badge">
                <span className="trust-icon">🔒</span>
                <span>Secure</span>
              </div>
            </div>
          </div>

          {/* Product Links */}
          <div className="footer-section">
          </div>

          {/* Product Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><Link to="/evidence">Upload Evidence</Link></li>
              <li><Link to="/verify">Verify Evidence</Link></li>
              <li><Link to="/enterprise">Enterprise Solutions</Link></li>
            </ul>
          </div>

          {/* Use Cases */}
          <div className="footer-section">
            <h4 className="footer-heading">Solutions</h4>
            <ul className="footer-links">
              <li><Link to="/use-cases#hostile-discovery">Hostile Discovery</Link></li>
              <li><Link to="/use-cases#media-integrity">Media Integrity</Link></li>
              <li><Link to="/use-cases#chain-of-custody">Chain of Custody</Link></li>
            </ul>
          </div>


        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} Evidencer. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <a href="/privacy">Privacy Policy</a>
              <span className="separator">•</span>
              <a href="/terms">Terms of Service</a>
              <span className="separator">•</span>
              <a href="/security">Security</a>
            </div>
          </div>

          {/* Professional Statement */}
          <div className="footer-disclaimer">
            <p>
              Evidencer provides evidence verification infrastructure using cryptographic
              methods and distributed systems. This service is designed to support legal
              and compliance requirements but does not constitute legal advice.
              Consult qualified legal counsel for specific guidance.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
